export function beaconAssert(condition, message) {
    if (!condition) {
        beaconFail(message);
    }
}
export function beaconFail(message) {
    // eslint-disable-next-line no-debugger
    debugger;
    throw new Error(message);
}
//# sourceMappingURL=assertions.js.map